import { ProposalTargetPreviewField } from 'components/brand/offers/types';
import { Fragment } from 'react';
import styled from 'styled-components';

const Diff = styled.dl`
  display: grid;
  grid-template-columns: minmax(7rem, 0.6fr) repeat(2, minmax(0, 1fr));
  margin: 0;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-medium);
  overflow: hidden;

  dt,
  dd {
    margin: 0;
    padding: var(--spacing-2);
    border-bottom: 1px solid var(--border-color);
    overflow-wrap: anywhere;
  }

  dd[data-changed='true'] {
    background: var(--success-background-color, var(--gray-1));
  }
`;

interface ExistingOfferDiffProps {
  fields: ProposalTargetPreviewField[];
  afterLabel?: string;
}

export const ExistingOfferDiff = ({
  fields,
  afterLabel = 'Proposed update',
}: ExistingOfferDiffProps): JSX.Element => (
  <Diff aria-label="Offer update preview">
    <dt>Field</dt>
    <dt>Existing offer</dt>
    <dt>{afterLabel}</dt>
    {fields.map((field) => (
      <Fragment key={field.label}>
        <dt>{field.label}</dt>
        <dd>{field.current ?? 'None'}</dd>
        <dd data-changed={field.changed}>{field.after ?? 'None'}</dd>
      </Fragment>
    ))}
  </Diff>
);
